import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  cleanAddressString,
  FORMATE_AMOUNT,
  FORMATE_DATE,
  PARSIFY,
} from '../../../helpers/helpers';
import { getAllCanceledShipmentsQuery } from '../../../api/services/shipments.service';
import { storeCanceledShipmentsAction } from '../../../store/slices/shipmentsSlice';
import { SHIPMENTS } from '../../../constants/columns';

export const useCancelShipments = () => {
  const { canceledShipments } = useSelector((state) => state.shipments);
  console.log(canceledShipments, 'cancel shipments canceledShipments');

  const user = JSON.parse(localStorage.getItem('login-user'));
  const dispatch = useDispatch();

  useEffect(() => {
    user && fetchCanceledShipments();
  }, []);
  const fetchCanceledShipments = async () => {
    const { data } = await getAllCanceledShipmentsQuery();

    if (data) {
      dispatch(storeCanceledShipmentsAction(data));
    }
  };
  const safeParseJSON = (str, fallback = {}) => {
    try {
      return JSON.parse(str);
    } catch (error) {
      console.error('JSON Parse Error:', error.message, 'for string:', str);
      return fallback;
    }
  };

  const formattedShipmentsData =
    canceledShipments &&
    canceledShipments !== null &&
    canceledShipments !== undefined &&
    canceledShipments?.length > 0 &&
    canceledShipments?.map((shipment) => {
      const parsedTo = safeParseJSON(shipment?.to, {}); // Use safe parsing

      return SHIPMENTS.reduce(
        (acc, col) => {
          switch (col.name) {
            case 'from':
              acc[col.name] = shipment?.location?.entity?.name || 'N/A';
              break;
            case 'recipient':
              acc[col.name] = parsedTo.name || '---';
              break;
            case 'reference':
              acc[col.name] = parsedTo.reference || '---';
              break;
            case 'carrier':
              acc[col.name] = shipment?.carrier?.name || 'N/A';
              break;
            case 'pickup':
              acc[col.name] = shipment?.pickUpDate || 'Not Scheduled';
              break;
            case 'delivery':
              acc[col.name] = shipment?.deliveryDate
                ? new Date(shipment?.deliveryDate).toLocaleDateString()
                : 'Pending';
              break;
            case 'value':
              acc[col.name] = `$${shipment?.totalValue?.toFixed(2) || '0.00'}`;
              break;
            case 'premium':
              acc[col.name] = shipment?.premium
                ? `$${shipment?.premium}`
                : 'UNPAID';
              break;
            case 'confirmation':
              acc[col.name] = shipment?.confirmationId || 'N/A';
              break;
            case 'trialed':
              acc[col.name] = shipment?.subscribers === 'true';
              break;
            case 'action':
              acc[col.name] = ''; // Placeholder action
              break;
            default:
              acc[col.name] = 'N/A';
          }
          return acc;
        },
        { id: shipment?.id }
      );
    });

  return {
    data: formattedShipmentsData,
  };
};
